import type { FormEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthStepHeader from "./AuthStepHeader";
import { Button, PasswordInput } from "../design";
import type { AuthScreen } from "../../pages/auth/authFlow";
import "./AuthForm.css";

interface PasswordFormProps {
  title: string;
  subtitle: string;
  isTwo: boolean;
  isProvidePassword?: boolean;
  passwordValue: string;
  onChangePassword: (event: React.ChangeEvent<HTMLInputElement>) => void;
  repeatPasswordValue: string;
  submitHandler: FormEventHandler<HTMLFormElement>;
  /** request in flight: spinner on the submit button */
  loading: boolean;
  setCurrentScreen: (screen: AuthScreen) => void;
  sendOtpFun: () => void;
  inputError: string;
  setInputError: (error: string) => void;
}

const PasswordForm = ({
  title,
  subtitle,
  isTwo,
  isProvidePassword = true,
  passwordValue,
  onChangePassword,
  repeatPasswordValue,
  submitHandler,
  loading,
  setCurrentScreen,
  sendOtpFun,
  inputError,
  setInputError,
}: PasswordFormProps) => {
  const { _t } = useTranslator();
  return (
    <form onSubmit={submitHandler} className="auth-step">
      <AuthStepHeader
        onBack={() => setCurrentScreen("email")}
        title={title}
        subtitle={subtitle}
      />
      <PasswordInput
        name="password"
        onChange={onChangePassword}
        value={passwordValue}
        inputError={inputError}
        setInputError={setInputError}
        isShowChecks={isTwo}
      />
      {isProvidePassword && (
        <Button
          variant="link"
          className="auth-link-end"
          onClick={() => setCurrentScreen("forgotPassword")}
        >
          {_t("forgotPassword")}
        </Button>
      )}
      {isTwo && (
        <PasswordInput
          name="confirmPassword"
          value={repeatPasswordValue}
          label={_t("repeatPassword")}
          onChange={onChangePassword}
          inputError={inputError}
          setInputError={setInputError}
        />
      )}
      {inputError && (
        <p className="auth-error" role="alert">
          {inputError}
        </p>
      )}
      <Button type="submit" size="lg" block loading={loading}>
        {_t("submit")}
      </Button>
      {isProvidePassword && (
        <p className="auth-footer">
          {_t("continueWithOtp")}{" "}
          <Button
            variant="link"
            onClick={() => {
              sendOtpFun();
              setCurrentScreen("verifyOtp");
            }}
          >
            {_t("clickHere")}
          </Button>
        </p>
      )}
    </form>
  );
};

export default PasswordForm;
